const searchClient = algoliasearch(
    'ZEEHQHR5CV',
    '65d535461c9a3e8285625544b61c24c4'
);

const search = instantsearch({
  indexName: 'shopify_products', // your Algolia products index name
  searchClient,
});

search.addWidgets([
  instantsearch.widgets.searchBox({
    container: '#searchbox', // update this selector to match your search page
  }),

  instantsearch.widgets.hits({
    container: '#hits', // update this selector to match your search page
  })
]);

search.start();
